import { FC } from "react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { IStayDatesDataTypes } from "../../types/IFormData";

interface StayDatesFormComponentProps {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
  dates: string[];
  stayDatesData: IStayDatesDataTypes;
}

const StayDatesFormComponent: FC<StayDatesFormComponentProps> = ({
  register,
  errors,
  dates,
  stayDatesData,
}) => {
  function formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    return `${day}.${month}.`;
  }

  return (
    <div className="sm:col-span-2">
      <label className="block text-sm font-medium mb-1">
        {stayDatesData.label}
        {errors[stayDatesData.name]?.message && (
          <span className="ml-1 text-primary-dark font-medium">*</span>
        )}
      </label>
      <div className="flex space-x-4">
        {dates.map((date, index) => (
          <label key={index}>
            <input
              type={stayDatesData.inputType}
              value={date}
              className="mr-2"
              {...register(stayDatesData.name, {
                required: stayDatesData.requiredErrorMessage,
              })}
            />
            {formatDate(date)}
          </label>
        ))}
      </div>
      {typeof errors[stayDatesData.name]?.message === "string" && (
        <span className="text-primary-dark text-sm font-medium">{`${
          errors[stayDatesData.name]?.message
        }`}</span>
      )}
    </div>
  );
};

export default StayDatesFormComponent;
